import { render, staticRenderFns } from "./faceChatxbk.vue?vue&type=template&id=63bcff38&scoped=true"
import script from "./faceChatxbk.vue?vue&type=script&lang=js"
export * from "./faceChatxbk.vue?vue&type=script&lang=js"
import style0 from "./faceChatxbk.vue?vue&type=style&index=0&id=63bcff38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bcff38",
  null
  
)

export default component.exports